var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MgsInput',{attrs:{"type":"number","min":"0","value":_vm.$store.warenkorb.indexedEntries[_vm.biid] || 0},on:{"input":function($event){_vm.$store.warenkorb.update(_vm.biid, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }